/* ============
 * The initial state of the auth module.
 * ============
 */
import storage from '@/utils/storage';
import appProperties from '@/constants/app.properties';

const defaultPermissions = {
  assign: false,
  create: false,
  modify: false,
  delete: false
};

export default {
  authenticated: Boolean(storage.getItem(appProperties.ACCESS_TOKEN_KEY)),
  authenticating: false,
  user: {},
  error: '',
  loading: false,
  access: {},
  currentModule: '',
  modulePermissions: {
    alert: defaultPermissions,
    careplan: defaultPermissions,
    patient: defaultPermissions,
    patientprogress: defaultPermissions,
    profile: defaultPermissions,
    user: defaultPermissions,
    delegate: defaultPermissions,
    group: defaultPermissions,
  }
};
